<tcc-mono-dialog-layout
  [title]="'Locatie UBN ' + ubn"
  [displayBottomButtons]="false"
>
  <div class="ubn-map-content">
    <div *ngIf="loading" class="loading-state ion-text-center ion-padding">
      <ion-spinner></ion-spinner>
      <p>Locatie ophalen bij RVO...</p>
    </div>

    <ng-container *ngIf="!loading">
      <div *ngIf="error" class="error-box">{{ error }}</div>
      <p *ngIf="error && fallbackAddress" class="fallback-address">
        Bekend adres uit verblijfplaats:
        <strong>{{ fallbackAddress }}</strong>
      </p>

      <div *ngIf="ubn" class="location-card">
        <div class="location-card__icon">
          <fa-icon [icon]="['fal', 'map']"></fa-icon>
        </div>
        <div class="location-card__body">
          <p *ngIf="holderName || existingStable?.name" class="location-card__name">
            {{ holderName || existingStable?.name }}
          </p>
          <p *ngIf="addressLine" class="location-card__address">{{ addressLine }}</p>
          <div class="location-card__tags">
            <span class="tag tag--ubn">{{ ubn }}</span>
            <span *ngIf="bedrijfstypeCode" class="tag tag--type">
              {{ bedrijfstypeLabelText }} ({{ bedrijfstypeCode }})
            </span>
            <span *ngIf="existingStable" class="tag tag--crm">In CRM</span>
          </div>
        </div>
        <div class="location-card__actions">
          <ion-spinner *ngIf="stableLookupLoading" name="crescent"></ion-spinner>
          <a
            *ngIf="!stableLookupLoading && existingStable"
            class="location-card__action"
            [href]="stableHref()"
            target="_blank"
            rel="noopener noreferrer"
          >
            Stal openen
          </a>
          <button
            *ngIf="!stableLookupLoading && !existingStable"
            type="button"
            class="location-card__action"
            (click)="createStable()"
          >
            Stal aanmaken
          </button>
        </div>
      </div>

      <ng-container *ngIf="mapEmbedUrl">
        <div class="map-frame">
          <iframe
            class="map-embed"
            [src]="mapEmbedUrl"
            referrerpolicy="no-referrer-when-downgrade"
            [title]="'Kaart locatie UBN ' + ubn"
          ></iframe>
        </div>

        <div class="map-footer">
          <span>© OpenStreetMap-bijdragers</span>
          <a *ngIf="externalMapUrl" [href]="externalMapUrl" target="_blank" rel="noopener noreferrer">
            Open in OpenStreetMap ↗
          </a>
        </div>
      </ng-container>

      <div *ngIf="isVeehouder" class="growth-section">
        <div class="section-tabs">
          <button
            type="button"
            class="section-tab"
            [class.section-tab--active]="activeTab === 'animals'"
            (click)="setActiveTab('animals')"
          >
            Dieren &amp; daggroei
          </button>
          <button
            type="button"
            class="section-tab"
            [class.section-tab--active]="activeTab === 'traders'"
            (click)="setActiveTab('traders')"
          >
            Handelaren
          </button>
        </div>

        <ng-container *ngIf="activeTab === 'animals'">
        <div class="growth-toolbar">
          <h3 class="growth-toolbar__title">UBN MVH</h3>

          <label class="growth-filter">
            <input
              type="checkbox"
              [checked]="withGrowthOnly"
              (change)="onWithGrowthOnlyChange($event)"
            />
            Alleen met daggroei
          </label>

          <div class="growth-toolbar__field">
            <span class="growth-toolbar__label">Geslacht</span>
            <ion-select
              class="growth-toolbar__select"
              [value]="animalGenderFilter"
              interface="popover"
              placeholder="Alle"
              (ionChange)="onAnimalGenderFilterChange($any($event).detail.value)"
            >
              <ion-select-option value="">Alle</ion-select-option>
              <ion-select-option value="M">Stier</ion-select-option>
              <ion-select-option value="V">Vaars</ion-select-option>
            </ion-select>
          </div>

          <div class="growth-toolbar__field">
            <span class="growth-toolbar__label">Haarkleur</span>
            <ion-select
              class="growth-toolbar__select growth-toolbar__select--color"
              [value]="animalColorFilter"
              interface="popover"
              placeholder="Alle"
              (ionChange)="onAnimalColorFilterChange($any($event).detail.value)"
            >
              <ion-select-option value="">Alle</ion-select-option>
              <ion-select-option *ngFor="let color of colors" [value]="color.code">
                {{ color.name }} ({{ color.code }})
              </ion-select-option>
            </ion-select>
          </div>

          <ion-button
            class="growth-toolbar__clear"
            fill="clear"
            size="small"
            [disabled]="!animalGenderFilter && !animalColorFilter"
            (click)="clearAnimalFilters()"
          >
            Filters wissen
          </ion-button>
        </div>

        <div *ngIf="animalsLoading" class="growth-loading ion-text-center ion-padding">
          <ion-spinner name="crescent"></ion-spinner>
          <p>Daggroei ophalen...</p>
        </div>

        <div *ngIf="!animalsLoading && animalsError" class="warning-box">
          {{ animalsError }}
        </div>

        <ng-container *ngIf="!animalsLoading && !animalsError && stats as s">
          <div class="stats-grid">
            <div class="stat-card">
              <p class="stat-card__label">Totaal dieren</p>
              <p class="stat-card__value">{{ s.total_animals }}</p>
            </div>
            <div class="stat-card">
              <p class="stat-card__label">Met daggroei</p>
              <p class="stat-card__value">{{ s.animals_with_growth }}</p>
            </div>
            <div class="stat-card">
              <p class="stat-card__label">Uitval</p>
              <p class="stat-card__value">{{ s.culled_animals }}</p>
            </div>
            <div class="stat-card stat-card--primary">
              <p class="stat-card__label">Gem. daggroei</p>
              <p class="stat-card__value">
                <ng-container *ngIf="s.avg_growth_per_day != null; else noAvg">
                  {{ s.avg_growth_per_day | number: '1.0-1' }}
                  <span class="stat-card__unit">g/dag</span>
                </ng-container>
                <ng-template #noAvg>—</ng-template>
              </p>
            </div>
          </div>

          <div class="stats-grid stats-grid--index" *ngIf="s.by_type">
            <div class="stat-card" *ngFor="let type of growthIndexTypes">
              <p class="stat-card__label">Index {{ type }}</p>
              <p
                class="stat-card__value"
                [class.stat-card__value--up]="growthIndexTone(s.by_type[type]?.growth_index_pct) === 'up'"
                [class.stat-card__value--down]="growthIndexTone(s.by_type[type]?.growth_index_pct) === 'down'"
              >
                <fa-icon
                  *ngIf="growthIndexTone(s.by_type[type]?.growth_index_pct) === 'up'"
                  [icon]="['fal', 'chevron-up']"
                ></fa-icon>
                <fa-icon
                  *ngIf="growthIndexTone(s.by_type[type]?.growth_index_pct) === 'down'"
                  [icon]="['fal', 'chevron-down']"
                ></fa-icon>
                {{ formatGrowthIndexPct(s.by_type[type]?.growth_index_pct) }}
              </p>
            </div>
          </div>

          <div class="animals-table-wrap">
            <div class="animals-table-scroll">
            <table class="animals-table">
              <thead>
                <tr>
                  <th>Oormerk</th>
                  <th>Haarkleur</th>
                  <th>Koppel</th>
                  <th>Type</th>
                  <th>Geslacht</th>
                  <th class="text-right">Start kg</th>
                  <th class="text-right">Geslachtgewicht</th>
                  <th
                    class="text-right sortable"
                    [class.is-sorted]="animalSortBy === 'age_at_arrival'"
                    title="Leeftijd bij opzet (levensdagen). Klik om te sorteren."
                    [attr.aria-sort]="animalSortAria('age_at_arrival')"
                  >
                    <button
                      type="button"
                      [class.is-active]="animalSortBy === 'age_at_arrival'"
                      (click)="sortAnimalsBy('age_at_arrival')"
                    >
                      Van
                      <fa-icon
                        class="sort-icon"
                        [class.sort-icon--idle]="animalSortBy !== 'age_at_arrival'"
                        [icon]="['fal', animalSortIcon('age_at_arrival')]"
                      ></fa-icon>
                    </button>
                  </th>
                  <th
                    class="text-right sortable"
                    [class.is-sorted]="animalSortBy === 'days_on_stable'"
                    title="Dagen op stal. Klik om te sorteren."
                    [attr.aria-sort]="animalSortAria('days_on_stable')"
                  >
                    <button
                      type="button"
                      [class.is-active]="animalSortBy === 'days_on_stable'"
                      (click)="sortAnimalsBy('days_on_stable')"
                    >
                      Op stal
                      <fa-icon
                        class="sort-icon"
                        [class.sort-icon--idle]="animalSortBy !== 'days_on_stable'"
                        [icon]="['fal', animalSortIcon('days_on_stable')]"
                      ></fa-icon>
                    </button>
                  </th>
                  <th
                    class="text-right sortable"
                    [class.is-sorted]="animalSortBy === 'age_at_end'"
                    title="Leeftijd bij afvoer, of nu als het dier nog op stal staat. Klik om te sorteren."
                    [attr.aria-sort]="animalSortAria('age_at_end')"
                  >
                    <button
                      type="button"
                      [class.is-active]="animalSortBy === 'age_at_end'"
                      (click)="sortAnimalsBy('age_at_end')"
                    >
                      Tot
                      <fa-icon
                        class="sort-icon"
                        [class.sort-icon--idle]="animalSortBy !== 'age_at_end'"
                        [icon]="['fal', animalSortIcon('age_at_end')]"
                      ></fa-icon>
                    </button>
                  </th>
                  <th>Status</th>
                  <th
                    class="text-right sortable"
                    [class.is-sorted]="animalSortBy === 'growth_per_day'"
                    title="Klik om te sorteren."
                    [attr.aria-sort]="animalSortAria('growth_per_day')"
                  >
                    <button
                      type="button"
                      [class.is-active]="animalSortBy === 'growth_per_day'"
                      (click)="sortAnimalsBy('growth_per_day')"
                    >
                      Daggroei
                      <fa-icon
                        class="sort-icon"
                        [class.sort-icon--idle]="animalSortBy !== 'growth_per_day'"
                        [icon]="['fal', animalSortIcon('growth_per_day')]"
                      ></fa-icon>
                    </button>
                  </th>
                  <th
                    class="text-right sortable"
                    [class.is-sorted]="animalSortBy === 'growth_index_pct'"
                    title="Klik om te sorteren."
                    [attr.aria-sort]="animalSortAria('growth_index_pct')"
                  >
                    <button
                      type="button"
                      [class.is-active]="animalSortBy === 'growth_index_pct'"
                      (click)="sortAnimalsBy('growth_index_pct')"
                    >
                      Index
                      <fa-icon
                        class="sort-icon"
                        [class.sort-icon--idle]="animalSortBy !== 'growth_index_pct'"
                        [icon]="['fal', animalSortIcon('growth_index_pct')]"
                      ></fa-icon>
                    </button>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let animal of animals"
                  [class.clickable]="canOpenKoppel(animal)"
                >
                  <td class="mono">
                    <a
                      *ngIf="koppelHref(animal) as href; else plainEarTag"
                      [href]="href"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="animal-link"
                      title="Open koppel in nieuw tabblad"
                    >
                      {{ animal.country_code }}{{ animal.identification_number }}
                      <span aria-hidden="true">↗</span>
                    </a>
                    <ng-template #plainEarTag>
                      {{ animal.country_code }}{{ animal.identification_number }}
                    </ng-template>
                  </td>
                  <td>{{ animal.color_code || '—' }}</td>
                  <td>
                    <a
                      *ngIf="koppelHref(animal) as href; else plainKoppel"
                      [href]="href"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="animal-link"
                      title="Open koppel in nieuw tabblad"
                    >
                      {{ animal.koppel_number || '—' }}
                    </a>
                    <ng-template #plainKoppel>
                      {{ animal.koppel_number || '—' }}
                    </ng-template>
                  </td>
                  <td class="capitalize">{{ animal.koppel_type || '—' }}</td>
                  <td [class.gender-male]="animal.gender_code === 'M'" [class.gender-female]="animal.gender_code === 'V'">
                    {{ formatGenderLabel(animal.gender_code, animal.gender_name) }}
                  </td>
                  <td class="text-right">{{ animal.start_weight || '—' }}</td>
                  <td class="text-right">{{ formatSlaughterWeight(animal) }}</td>
                  <td
                    class="text-right"
                    [class.sort-col]="animalSortBy === 'age_at_arrival'"
                  >{{ formatDays(animal.age_at_arrival) }}</td>
                  <td
                    class="text-right"
                    [class.sort-col]="animalSortBy === 'days_on_stable'"
                  >{{ formatDays(animal.days_on_stable) }}</td>
                  <td
                    class="text-right"
                    [class.sort-col]="animalSortBy === 'age_at_end'"
                  >{{ formatDays(animal.age_at_end) }}</td>
                  <td>{{ animal.status || '—' }}</td>
                  <td
                    class="text-right"
                    [class.sort-col]="animalSortBy === 'growth_per_day'"
                    [class.growth-up]="growthIndexTone(animal.growth_index_pct) === 'up'"
                    [class.growth-down]="growthIndexTone(animal.growth_index_pct) === 'down'"
                  >
                    <ng-container *ngIf="animal.growth_per_day != null; else noGrowth">
                      {{ animal.growth_per_day | number: '1.0-1' }} g
                    </ng-container>
                    <ng-template #noGrowth>—</ng-template>
                  </td>
                  <td
                    class="text-right growth-index-cell"
                    [class.sort-col]="animalSortBy === 'growth_index_pct'"
                    [class.growth-up]="growthIndexTone(animal.growth_index_pct) === 'up'"
                    [class.growth-down]="growthIndexTone(animal.growth_index_pct) === 'down'"
                  >
                    <fa-icon
                      *ngIf="growthIndexTone(animal.growth_index_pct) === 'up'"
                      [icon]="['fal', 'chevron-up']"
                    ></fa-icon>
                    <fa-icon
                      *ngIf="growthIndexTone(animal.growth_index_pct) === 'down'"
                      [icon]="['fal', 'chevron-down']"
                    ></fa-icon>
                    {{ formatGrowthIndexPct(animal.growth_index_pct) }}
                  </td>
                </tr>
                <tr *ngIf="animals.length === 0">
                  <td colspan="13" class="empty">Geen dieren gevonden voor dit UBN.</td>
                </tr>
              </tbody>
            </table>
            </div>

            <div *ngIf="lastPage > 1" class="pager">
              <span>Pagina {{ page }} van {{ lastPage }} ({{ total }} dieren)</span>
              <div class="pager__actions">
                <ion-button
                  size="small"
                  fill="outline"
                  [disabled]="page <= 1 || animalsLoading"
                  (click)="goToPage(page - 1)"
                >
                  Vorige
                </ion-button>
                <ion-button
                  size="small"
                  fill="outline"
                  [disabled]="page >= lastPage || animalsLoading"
                  (click)="goToPage(page + 1)"
                >
                  Volgende
                </ion-button>
              </div>
            </div>
          </div>
        </ng-container>
        </ng-container>

        <ng-container *ngIf="activeTab === 'traders'">
          <div class="growth-toolbar">
            <h3 class="growth-toolbar__title">Handelaren (geladen bij dit UBN)</h3>
            <div class="period-toggle">
              <button
                type="button"
                class="period-toggle__btn"
                [class.period-toggle__btn--active]="traderPeriod === 'year'"
                (click)="setTraderPeriod('year')"
              >
                Afgelopen jaar
              </button>
              <button
                type="button"
                class="period-toggle__btn"
                [class.period-toggle__btn--active]="traderPeriod === 'all'"
                (click)="setTraderPeriod('all')"
              >
                Altijd
              </button>
            </div>
            <ion-button
              class="growth-toolbar__clear"
              fill="clear"
              size="small"
              [disabled]="tradersLoading"
              (click)="reloadTraders()"
            >
              Vernieuwen
            </ion-button>
          </div>

          <div *ngIf="tradersLoading" class="growth-loading ion-text-center ion-padding">
            <ion-spinner name="crescent"></ion-spinner>
            <p>Handelaren ophalen...</p>
          </div>

          <div *ngIf="!tradersLoading && tradersError" class="warning-box">
            {{ tradersError }}
          </div>

          <p
            *ngIf="!tradersLoading && !tradersError && traders.length === 0"
            class="traders-empty"
          >
            Geen handelaren gevonden die bij dit UBN hebben geladen
            {{ traderPeriod === 'year' ? 'in het afgelopen jaar' : '' }}.
          </p>

          <div
            *ngIf="!tradersLoading && !tradersError && traders.length > 0"
            class="animals-table-wrap"
          >
            <table class="animals-table">
              <thead>
                <tr>
                  <th></th>
                  <th>Handelaar</th>
                  <th class="text-right">Dieren</th>
                  <th class="text-right">Ritten</th>
                  <th class="text-right">Laatst geladen</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let trader of traders">
                  <tr
                    class="trader-row"
                    [class.is-open]="expandedTraderId === trader.id"
                    (click)="toggleTraderRides(trader)"
                  >
                    <td class="trader-row__toggle">
                      <fa-icon [icon]="['fal', expandedTraderId === trader.id ? 'chevron-down' : 'chevron-right']"></fa-icon>
                    </td>
                    <td>
                      <div class="trader-name">{{ trader.name }}</div>
                      <div *ngIf="trader.relation_number" class="trader-number">
                        {{ trader.relation_number }}
                      </div>
                    </td>
                    <td class="text-right">{{ trader.animals_count }}</td>
                    <td class="text-right">{{ trader.rides_count }}</td>
                    <td class="text-right">{{ formatTraderDate(trader.last_loaded_at) }}</td>
                  </tr>
                  <tr *ngIf="expandedTraderId === trader.id" class="trader-rides">
                    <td colspan="5">
                      <div *ngIf="traderRidesLoading" class="trader-rides__status">Ritten laden...</div>
                      <div *ngIf="!traderRidesLoading && traderRidesError" class="warning-box">
                        {{ traderRidesError }}
                      </div>
                      <p
                        *ngIf="!traderRidesLoading && !traderRidesError && traderRides.length === 0"
                        class="trader-rides__status"
                      >
                        Geen ritten gevonden.
                      </p>
                      <div *ngIf="!traderRidesLoading && !traderRidesError && traderRides.length > 0" class="ride-cards">
                        <article *ngFor="let ride of traderRides" class="ride-card">
                          <div class="ride-card__head">
                            <a
                              class="animal-link"
                              [href]="rideHref(ride)"
                              target="_blank"
                              rel="noopener noreferrer"
                              (click)="$event.stopPropagation()"
                            >
                              Rit {{ ride.number || ride.id }}
                              <span aria-hidden="true">↗</span>
                            </a>
                            <span class="tag tag--type">{{ formatRideOrigin(ride.origin) }}</span>
                            <span
                              *ngIf="rideHasOtherRelation(ride)"
                              class="tag tag--mismatch ride-card__mismatch"
                            >
                              Andere relatie dan inkooporder
                              <strong>{{ ride.relation_name || 'Onbekend' }}</strong>
                            </span>
                          </div>
                          <p class="ride-card__meta">
                            {{ formatTraderDate(ride.loaded_at) }}
                            · {{ ride.animals_count }} dieren
                            <ng-container *ngIf="ride.license_plate"> · {{ ride.license_plate }}</ng-container>
                            <ng-container *ngIf="ride.destination_name || ride.destination_ubn">
                              · {{ ride.destination_name || ride.destination_ubn }}
                            </ng-container>
                          </p>
                          <p *ngIf="ride.purchase_orders.length === 0" class="ride-card__empty">
                            Geen inkooporder op deze rit.
                          </p>
                          <ul *ngIf="ride.purchase_orders.length > 0" class="ride-card__orders">
                            <li *ngFor="let order of ride.purchase_orders">
                              <a
                                class="animal-link"
                                [href]="purchaseOrderHref(order)"
                                target="_blank"
                                rel="noopener noreferrer"
                                (click)="$event.stopPropagation()"
                              >
                                {{ order.order_number }}
                                <span aria-hidden="true">↗</span>
                              </a>
                              <span>
                                {{ order.relation_name || 'Onbekende relatie' }}
                              </span>
                            </li>
                          </ul>
                        </article>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
</tcc-mono-dialog-layout>
